import Glide from '@glidejs/glide'


/**
 * @see https://glidejs.com/docs/options/
 */
const setupSlideshows = () =>
{
	const glideContainers = document.querySelectorAll( '.glide' );

	glideContainers.forEach( glideContainer =>
	{
		const autoplayAttr = glideContainer.dataset.autoplay;
		const perViewAttr  = glideContainer.dataset.perView;
		const modalIdAttr  = glideContainer.dataset.modalId;
		const perView      = perViewAttr !== undefined ? parseInt( perViewAttr, 10 ) : 1;
		const gap          = perView === 1 ? 0 : 20;
		let autoplay       = false;
		let doMount        = true;

		if (autoplayAttr !== undefined && autoplayAttr !== 'false') {
			autoplay = autoplayAttr === '' || autoplayAttr === 'true' ? 4000 : parseInt( autoplayAttr, 10 )
		}

		const glide = new Glide( glideContainer, {
			type:              'carousel',
			perView:           perView,
			autoplay:          autoplay,
			gap:               gap,
			animationDuration: 600,
			hoverpause:        false,
			//animationTimingFunc: 'ease-in-out',
		} );

		// if slideshow is in a bootstrap modal, delay initialization until the modal has been opened - otherwise slide width will be zero.

		if (modalIdAttr) {

			const modal = document.querySelector( '#' + modalIdAttr );

			if (modal instanceof Element) {

				doMount = false;
				modal.addEventListener( 'shown.bs.modal', () => glide.mount() );
				modal.addEventListener( 'hide.bs.modal', () => glide.destroy() );
			}
		}

		if (doMount) {
			glide.mount();
		}
	} );
};


/**
 *
 */
export default setupSlideshows;